import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const pricingPlansReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.PRICING_PLANS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.PRICING_PLANS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.PRICING_PLANS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { pricingPlansReducer };
